module.exports = __webpack_public_path__ + "static/media/test7_2.612e945b.png";